"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipHint = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TooltipHint = _styledComponents.default.span.withConfig({
  displayName: "TooltipHint",
  componentId: "sc-1wwbc8j-0"
})(["background-image:linear-gradient(to right,#000 75%,transparent 75%);background-position:0 1.15em;background-size:4px 2px;background-repeat:repeat-x;@media print{background-image:none;}"]);

exports.TooltipHint = TooltipHint;